import { useTranslation } from "react-i18next";

const values = [
  { titleKey: "about.values.card1.title", descKey: "about.values.card1.desc", icon: "ri-speed-line", stat: "50%" },
  { titleKey: "about.values.card2.title", descKey: "about.values.card2.desc", icon: "ri-leaf-line", stat: "淨零" },
  { titleKey: "about.values.card3.title", descKey: "about.values.card3.desc", icon: "ri-sun-line", stat: "舒適" },
];

export default function ValuesSection() {
  const { t } = useTranslation();

  return (
    <section className="section-padding bg-cream">
      <div className="container-main">
        <div className="text-center max-w-2xl mx-auto mb-12 md:mb-16">
          <span className="tag-label mb-4 inline-block">{t("about.values.label")}</span>
          <h2 className="mb-4">{t("about.values.title")}</h2>
          <p className="text-medium-gray text-[1.0625rem]">{t("about.values.desc")}</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 lg:gap-8">
          {values.map((v) => (
            <div
              key={v.titleKey}
              className="bg-white rounded-xl p-7 md:p-8 border border-warm-gray/60 text-center transition-all duration-300 hover:-translate-y-1 hover:border-champagne/40"
            >
              <div className="text-champagne font-serif text-4xl md:text-5xl font-bold mb-5">
                {v.stat}
              </div>
              <div className="w-12 h-12 flex items-center justify-center rounded-full bg-champagne/10 mx-auto mb-4 transition-all duration-300 hover:scale-110 hover:bg-champagne/20">
                <i className={`${v.icon} text-2xl text-champagne`} />
              </div>
              <h3 className="text-[1.25rem] md:text-[1.375rem] mb-3">{t(v.titleKey)}</h3>
              <p className="text-medium-gray text-[1rem] mb-0">{t(v.descKey)}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}